module.exports = __webpack_public_path__ + "assets/img/1_551_big.2232d8e0.jpg";